module.exports = __webpack_public_path__ + "static/media/authorityIcon.92dbadd5.png";